import { render, staticRenderFns } from "./CiVonWebseite.vue?vue&type=template&id=56b99a56&scoped=true"
import script from "./CiVonWebseite.vue?vue&type=script&lang=js"
export * from "./CiVonWebseite.vue?vue&type=script&lang=js"
import style0 from "./CiVonWebseite.vue?vue&type=style&index=0&id=56b99a56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b99a56",
  null
  
)

export default component.exports